var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11752_8423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5288 14.5299C15.9088 15.7899 14.5687 16.6699 12.9987 16.6699C11.4287 16.6699 10.0987 15.7899 9.46875 14.5299",
    stroke: "#7D7D7D",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.7019 11.1666C7.90372 10.1807 8.3399 9.49219 8.85095 9.49219C9.362 9.49219 9.79493 10.1807 10 11.1666",
    stroke: "#7D7D7D",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0027 11.1666C16.2045 10.1807 16.6407 9.49219 17.1517 9.49219C17.6628 9.49219 18.0957 10.1807 18.3008 11.1666",
    stroke: "#7D7D7D",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0008 23.4508C18.7722 23.4508 23.4508 18.7722 23.4508 13.0008C23.4508 7.22941 18.7722 2.55078 13.0008 2.55078C7.22941 2.55078 2.55078 7.22941 2.55078 13.0008C2.55078 18.7722 7.22941 23.4508 13.0008 23.4508Z",
    stroke: "#7D7D7D",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11752_8423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileIcon);
export default __webpack_public_path__ + "static/media/smile-icon.cc1dbc9ba65f14f0b26b00aa5cabfb23.svg";
export { ForwardRef as ReactComponent };